import { Box, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ColorScheme } from "../../Themes/ColorScheme";

let style = {
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	width: "100%",
	alignSelf: "center",
	boxSizing: "border-box",
	overflow: "hidden",
    backgroundColor: ColorScheme.secondary,
};


export const SearchBar = ({
	text, 
	valueChange,
}) => {
	const handleInputChange = (input) => {
		const value = input.target.value;
		valueChange(value);
	};

    const { t } = useTranslation();

	return (
		<Box
			style={{
				...style,
			}}
		>
			<TextField
				variant="standard"
				label={t("textfield_labels.search")}
				placeholder={t("textfield_labels.search")}
				sx={{
                    width: "100%",
                    alignItems: "end", // aligns helpertext to right if it exists
                    '& .MuiInput-underline:before': {
                      borderBottomColor: ColorScheme.black + ColorScheme.opacity10, // Default underline color
                      borderBottomWidth: '3px', // Default underline width
                    },
                    '& .MuiInput-underline:hover:before': {
                      borderBottomColor: ColorScheme.black + ColorScheme.opacity50, // Hover underline color
                      borderBottomWidth: '3px', // Hover underline width
                    },
                    '& .MuiInput-underline:after': {
                      borderBottomColor: ColorScheme.primary, // Focused underline color
                      borderBottomWidth: '3px', // Focused underline width
                    },
                  }}
				InputProps={{
                    style: {
                      width: "100%",
                      color: ColorScheme.black,
                      backgroundColor: ColorScheme.transparent,
                      borderRadius: "20px",
                      fontSize: "15px",
                      padding: "10px 15px", // Add padding to the input text and placeholder
                    },
                  }}
				InputLabelProps={{
					style: {
						fontSize: "14px",
						top: "3px",
                        padding: "0px 15px", // Add padding to the input text and placeholder
					}
				}}
				value={text}
				onChange={handleInputChange}
			/>
		</Box>
	);
};
